import { IMailingState } from "./state/MailingState";
import {initState, initMailing} from "./state/InitMailingState";
import { Action, Reducer } from "redux";
import { GET_MAILING_ITEM_INFO_SUCCESS, GET_ENABLED_CHANNELS_SUCCESS, CHANGE_NAME_SUCCESS, CHANGE_MESSAGE_SUCCESS, CHANGE_LINK_TEXT_SUCCESS, CHANGE_LINK_URL_SUCCESS, CHANGE_IMAGE_FILE_SUCCESS, CHANGE_IS_EMERGENCY_SUCCESS, SAVE_MAILING_SUCCESS, GET_MAILINGS_SUCCESS, REMOVE_ALL_MAILINGS_FROM_STATE_SUCCESS, START_MAILINGS_SUCCESS, DELETE_MAILING_SUCCESS, GET_MAILINGS_RECIPIENTS_SUCCESS, DELETE_RECIPIENTS_FROM_STATE_SUCCESS, GET_MAILINGS_START, GET_MAILINGS_ERROR, CHANGE_SEARCH_RECIPIENTS_TYPE_SUCCESS, SEARCH_CHATS_FOR_MAILING, SEARCH_CONTACTS_FOR_MAILING, CHANGE_MAILING_TYPE_SUCCESS, GET_ALL_BOTS_FOR_MAILING_SUCCESS, CHANGE_SELECTED_BOT_SUCCESS, CHANGE_BOT_ADDITIONAL_DATA_SUCCESS, CHANGE_SENDING_TYPE_SUCCESS, CHANGE_SELECTED_CHANNELS_SUCCESS, START_MAILINGS_START, START_MAILINGS_ERROR, STOP_MAILINGS_ERROR, STOP_MAILINGS_SUCCESS, CHANGE_DISABLE_LINK_TRACKING_SUCCESS, GET_MAILINGS_RECIPIENTS_START, GET_MAILINGS_RECIPIENTS_ERROR } from "./actions/types";
import { GetMailingItemInfoAction, GetEnabledChannelsActionSuccess, ChangeNameActionSuccess, ChangeMessageActionSuccess, ChangeButtonTextActionSuccess, ChangeButtonUrlActionSuccess, GetMailingsActionSuccess, StartMailingActionSuccess, DeleteMailingActionSuccess, GetRecipientsActionSuccess, ChangeImageFileSuccess, ChangeIsEmergencySuccess, ChangeSearchRecipientsTypeSuccess, ChangeMailingTypeActionSuccess, ChangeSelectedBotActionSuccess, ChangeBotAdditionalDataActionSuccess, ChangeSendingTypeSuccess, ChangeSelectedChannelsSuccess, StartMailingActionStart, StartMailingActionError, StopMailingActionSuccess, StopMailingActionError, ChangeDisableLinkTrackingSuccess } from "./actions/interfaces";
import { GetAllBotsSuccessAction, SearchChatsSuccessAction } from "src/app/chats/~store/actions/interfaces";
import { SearchRecipientsType } from "./models/enums/SearchRecipientsType";
import { toSearchingTag } from "src/app/shared/helpers/api-body-helper/searchInputHelper";
import { MAILING_REQUEST_COUNT } from "./MailingConstants";

export const mailingReducer: Reducer<IMailingState> = (
    state: IMailingState = initState,
    action: Action
): IMailingState => {


    switch(action.type){
        case GET_MAILING_ITEM_INFO_SUCCESS: {
            const mailing = (action as GetMailingItemInfoAction).payload.mailing;
            const allBots = state.mailingItemInfo.mailing.allBots;

            const tags = toSearchingTag(mailing?.recipientFilter?.searchingTags as any);
            if (mailing.recipientFilter?.recipientFilter === SearchRecipientsType.inChats)
                mailing.searchingTagsForChats = tags;
            else if (mailing.recipientFilter?.recipientFilter === SearchRecipientsType.inContacts)
                mailing.searchingTagsForContacts = tags;

            mailing.searchRecipientsType = mailing.recipientFilter?.recipientFilter ?? SearchRecipientsType.inContacts;
            mailing.allBots = allBots;

            return {
                ...state,
                mailingItemInfo: {...state.mailingItemInfo, mailing}
            }
        }

        case GET_ENABLED_CHANNELS_SUCCESS: {
            const channels = (action as GetEnabledChannelsActionSuccess).payload.channels;
            return {
                ...state,
                mailingItemInfo: {...state.mailingItemInfo, enabledChannels: channels}
            }
        }

        case GET_MAILINGS_RECIPIENTS_START: {
            return {
                ...state,
                mailingItemInfo: {...state.mailingItemInfo, isReceivingRecipients: true}
            }
        }

        case GET_MAILINGS_RECIPIENTS_SUCCESS: {
            const {recipients, mailingId } = (action as GetRecipientsActionSuccess).payload;
            const oldRecipients = state.mailingItemInfo.recipients.filter(r => r.mailingId === mailingId);
            
            return {
                ...state,
                mailingItemInfo: {...state.mailingItemInfo, recipients: oldRecipients.concat(recipients), isReceivingRecipients: false}
            }
        }

        case GET_MAILINGS_RECIPIENTS_ERROR: {
            return {
                ...state,
                mailingItemInfo: {...state.mailingItemInfo, isReceivingRecipients: false}
            }
        }

        case DELETE_RECIPIENTS_FROM_STATE_SUCCESS: {
            return {
                ...state,
                mailingItemInfo: {...state.mailingItemInfo, recipients: []}
            }
        }

        case CHANGE_NAME_SUCCESS: {
            const name = (action as ChangeNameActionSuccess).payload.name;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.name = name;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        name
                    }
                }
            }
        }

        case CHANGE_MAILING_TYPE_SUCCESS: {
            const mailingType = (action as ChangeMailingTypeActionSuccess).payload.mailingType;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.mailingType = mailingType;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        mailingType
                    }
                }
            }
        }

        case GET_ALL_BOTS_FOR_MAILING_SUCCESS: {
            const allBots = (action as GetAllBotsSuccessAction).payload.allBots;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.allBots = allBots;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        allBots
                    }
                }
            }
        }

        case CHANGE_MESSAGE_SUCCESS: {
            const text = (action as ChangeMessageActionSuccess).payload.message;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.text = text;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        text
                    }
                }
            }
        }

        case CHANGE_SELECTED_BOT_SUCCESS: {
            const selectedBot = (action as ChangeSelectedBotActionSuccess).payload.selectedBot;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.botStartParams.sb = selectedBot;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        botStartParams: {
                            ...state.mailingItemInfo.mailing.botStartParams,
                            sb: selectedBot
                        }
                    }
                }
            }
        }

        case CHANGE_BOT_ADDITIONAL_DATA_SUCCESS: {
            const data = (action as ChangeBotAdditionalDataActionSuccess).payload.data;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.botStartParams.a = data;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        botStartParams: {
                            ...state.mailingItemInfo.mailing.botStartParams,
                            a: data
                        }
                    }
                }
            }
        }

        case CHANGE_LINK_TEXT_SUCCESS: {
            const buttonText = (action as ChangeButtonTextActionSuccess).payload.buttonText;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.buttonText = buttonText;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        buttonText
                    }
                }
            }
        }

        case CHANGE_LINK_URL_SUCCESS: {
            const buttonUrl = (action as ChangeButtonUrlActionSuccess).payload.buttonUrl;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.buttonUrl = buttonUrl;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        buttonUrl
                    }
                }
            }
        }

        case CHANGE_IMAGE_FILE_SUCCESS: {
            const image = (action as ChangeImageFileSuccess).payload.image;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.image = image;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        image,
                        pictureId: undefined
                    }
                }
            }
        }

        case CHANGE_IS_EMERGENCY_SUCCESS: {
            const isEmergency = (action as ChangeIsEmergencySuccess).payload.isEmergency;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.isEmergency = isEmergency;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        isEmergency
                    }
                }
            }
        }

        case CHANGE_DISABLE_LINK_TRACKING_SUCCESS: {
            const disableLinkTracking = (action as ChangeDisableLinkTrackingSuccess).payload.disableLinkTracking;
            const newMailing = state.mailingItemInfo.newMailing;
            if (state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.disableLinkTracking = disableLinkTracking;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        disableLinkTracking
                    }
                }
            }
        }

        case CHANGE_SENDING_TYPE_SUCCESS: {
            const sendingType = (action as ChangeSendingTypeSuccess).payload.sendingType;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.sendingType = sendingType;
                newMailing.channelsIds = [];
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        sendingType
                    }
                }
            }
        }

        case CHANGE_SELECTED_CHANNELS_SUCCESS: {
            const selectedChannels = (action as ChangeSelectedChannelsSuccess).payload.channelsIds;
            
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.channelsIds = [...selectedChannels];
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        channelsIds: [...selectedChannels]
                    }
                }
            }
        }

        case CHANGE_SEARCH_RECIPIENTS_TYPE_SUCCESS: {
            const searchRecipientsType = (action as ChangeSearchRecipientsTypeSuccess).payload.searchRecipientsType;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.searchRecipientsType = searchRecipientsType;
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        searchRecipientsType
                    }
                }
            }
        }

        case SEARCH_CHATS_FOR_MAILING: {
            const { tags } = (action as SearchChatsSuccessAction).payload;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.searchingTagsForChats = tags ?? [];
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        searchingTagsForChats: [...tags ?? []]
                    }
                }
            }
        }

        case SEARCH_CONTACTS_FOR_MAILING: {
            const { tags } = (action as SearchChatsSuccessAction).payload;
            const newMailing = state.mailingItemInfo.newMailing;
            if(state.mailingItemInfo.mailing.mailingId === 0) {
                newMailing.searchingTagsForContacts = tags ?? [];
            }

            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing,
                    mailing: {
                        ...state.mailingItemInfo.mailing,
                        searchingTagsForContacts: [...tags ?? []]
                    }
                }
            }
        }

        case SAVE_MAILING_SUCCESS: {
            return {
                ...state,
                mailingItemInfo: {
                    ...state.mailingItemInfo,
                    newMailing: initMailing()
                }
            }
        }

        case GET_MAILINGS_START: {
            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    isReceivingmailings: true
                }
            }
        }

        case GET_MAILINGS_SUCCESS: {
            const mailings = (action as GetMailingsActionSuccess).payload.mailings;

            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    isReceivingmailings: false,
                    allMailings: state.mailingList.allMailings.concat(mailings),
                    isAllLoaded: mailings.length < MAILING_REQUEST_COUNT
                }
            }
        }

        case GET_MAILINGS_ERROR: {
            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    isReceivingmailings: false
                }
            }
        }

        case REMOVE_ALL_MAILINGS_FROM_STATE_SUCCESS: {
            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    allMailings: [],
                    isAllLoaded: false,
                }
            }
        }

        case START_MAILINGS_START: {
            const { mailingId } = (action as StartMailingActionStart).payload;

            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    allMailings: state.mailingList.allMailings.map(mailing =>
                        mailing.mailingId === mailingId
                            ? { ...mailing, isStarting: true }
                            : mailing
                    )
                }
            };
        }

        case START_MAILINGS_SUCCESS: {
            const sentMailing = (action as StartMailingActionSuccess).payload.sentMailing;

            const index = state.mailingList.allMailings.findIndex(x => x.mailingId === sentMailing.mailingId);
            const copyAllMailings = state.mailingList.allMailings.slice();
            if(index > -1) {
                copyAllMailings.splice(index, 1, { ...sentMailing, isStarting: false });
            }

            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    allMailings: copyAllMailings
                }
            }
        }

        case START_MAILINGS_ERROR: {
            const { mailingId } = (action as StartMailingActionError).payload;

            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    allMailings: state.mailingList.allMailings.map(mailing =>
                        mailing.mailingId === mailingId
                            ? { ...mailing, isStarting: false }
                            : mailing
                    )
                }
            };
        }

        case DELETE_MAILING_SUCCESS: {
            const mailingId = (action as DeleteMailingActionSuccess).payload.mailingId;

            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    allMailings: state.mailingList.allMailings.filter(x => x.mailingId !== mailingId)
                }
            }
        }

        case STOP_MAILINGS_ERROR: {
            const { mailingId } = (action as StopMailingActionError).payload;

            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    allMailings: state.mailingList.allMailings.map(mailing =>
                        mailing.mailingId === mailingId
                            ? { ...mailing, isStarting: false }
                            : mailing
                    )
                }
            };
        }

        case STOP_MAILINGS_SUCCESS: {
            const stoppedMailing = (action as StopMailingActionSuccess).payload.stoppedMailing;

            const index = state.mailingList.allMailings.findIndex(x => x.mailingId === stoppedMailing.mailingId);
            const copyAllMailings = state.mailingList.allMailings.slice();
            if (index > -1) {
                copyAllMailings.splice(index, 1, { ...stoppedMailing, isStarting: false });
            }

            return {
                ...state,
                mailingList: {
                    ...state.mailingList,
                    allMailings: copyAllMailings
                }
            }
        }
    }

    return state;
    
}
